import { reviewsData } from './reviewsData';

import type { ReviewsCarouselItemProps } from './reviewsData';
import type { ReviewCategory } from './categories';

interface GetReorderedReviewsByCategoryArgs {
  category: ReviewCategory;
}

export function getReorderedReviewsByCategory({
  category,
}: GetReorderedReviewsByCategoryArgs): ReviewsCarouselItemProps[] {
  let filteredReviews = reviewsData.filter(review =>
    review.categories.includes(category)
  );

  const videoReviews = filteredReviews.filter(
    review => 'mobileWistiaId' in review && !!review.mobileWistiaId
  );
  const nonVideoReviews = filteredReviews.filter(
    review => !('mobileWistiaId' in review && !!review.mobileWistiaId)
  );

  // We want to show the video reviews first if there are any, and then the rest of the reviews
  // If there are no video reviews, we just show the non-video reviews

  if (nonVideoReviews.length > 0 && videoReviews.length > 0) {
    filteredReviews = [
      nonVideoReviews[0],
      ...videoReviews,
      ...nonVideoReviews.slice(1),
    ];
  }

  return filteredReviews;
}
